import { service } from '@ember/service';
import Helper from '@ember/component/helper';

export default class IsClinicianSearchRouteHelper extends Helper {
  @service router;

  constructor() {
    super(...arguments);
    this.router.on('routeDidChange', this.onRouteDidChange);
  }

  willDestroy() {
    this.router.off('routeDidChange', this.onRouteDidChange);
    super.willDestroy();
  }

  onRouteDidChange = () => this.recompute();

  compute() {
    let currentRouteName = this.router.currentRouteName;
    return Boolean(currentRouteName && currentRouteName.endsWith('.clinician-search'));
  }
}
